import achievements from './achievements.json'
import assistant from './assistant.json'
import common from './common.json'
import domain from './domain.json'
import engine from './engine.json'
import legal from './legal.json'
import library from './library.json'
import motivation from './motivation.json'
import onboarding from './onboarding.json'
import plan from './plan.json'
import premium from './premium.json'
import profile from './profile.json'
import progress from './progress.json'
import session from './session.json'
import today from './today.json'

const es = {
  common,
  domain,
  engine,
  onboarding,
  today,
  plan,
  library,
  session,
  progress,
  achievements,
  motivation,
  profile,
  legal,
  assistant,
  premium,
}

export default es
